<template>
  <div
    class="p-detail-box"
  >
    <template v-if="itemDatsReady">
      <div class="p-detail-tit clearfix">
        <i class="icon iconfont iconicon-test28" />
        <span
          v-if="itemData.isfounder === 1"
          class="p-role"
        >{{ $t('message["130"]') }}</span>
        <span
          v-else-if="itemData.isadmin === 1"
          class="p-role admin-role"
        >{{ $t('message["416"]') }}</span>
        <template v-if="!isTruenameEdit">
          <strong>{{ itemData.truename }}</strong>
          <i
            class="iconfont iconicon-test66"
            @click="eidtTruename"
          />
        </template>
        <template v-if="itemData.truename && isTruenameEdit">
          <edit-truename
            :item-data="itemData"
            @saveEdit="saveEditTrue"
            @resetEdit="resetEdit"
          />
        </template>
      </div>
      <div class="form-box">
        <a-form>
          <div
            v-if="itemData.isfounder !== 1"
            class="tool-btn-box"
          >
            <a-button @click="setAdminHandler">
              {{ itemData.isadmin === 1 ? setAdminTxt[0]: setAdminTxt[1] }}
            </a-button>
            <user-del />
          </div>
          <template v-if="!$isDingDing">
            <!-- <a-form-item
              v-if="itemData.isfounder === 1 || (itemData.isadmin === 1)"
              :label="`${manageLimitTxt}：`"
              :label-col="{ span: 2 }"
              :wrapper-col="{ span: 19 }"
            >
              <span
                v-for="(item, index) in itemData.permission"
                :key="index"
              >{{ item }}
                <template v-if="index !== (itemData.permission.length-1)">、</template>
              </span>
            </a-form-item> -->
            <a-form-item
              :label-col="{ span: 2 }"
              :wrapper-col="{ span: 19 }"
              :label="`${mobileTit}：`"
            >
              <template v-if="itemData.mobile">
                {{ itemData.mobile }}
              </template>
              <span
                v-else
                class="company-name"
              >{{ $t('message["1543"]') }}</span>
            </a-form-item>
            <a-form-item
              :label-col="{ span: 2 }"
              :wrapper-col="{ span: 19 }"
              :label="`${emailTit}：`"
            >
              <template v-if="itemData.email">
                {{ itemData.email }}
              </template>
              <span
                v-else
                class="company-name"
              >{{ $t('message["1543"]') }}</span>
            </a-form-item>
          </template>
          <bind-three />
          <a-form-item
            :label="`${joinPro}：`"
            :label-col="{ span: 2 }"
            :wrapper-col="{ span: 19 }"
          >
            <template v-if="len">
              <p
                v-for="(item, index) in itemData.projectInfo"
                :key="index"
              >
                {{ item.projectname }} <span class="ml-24">[{{ item.roleInfo.rolename }}]</span>
              </p>
            </template>
            <span
              v-else
              class="company-name"
            >{{ $t('message["627"]') }}</span>
          </a-form-item>
        </a-form>
      </div>
    </template>
  </div>
</template>
<script>
import BindThree from './BindThree'
import UserDel from './UserDelete'
import { mapState, mapActions } from 'vuex'
import EditTruename from './EditTruename'

export default {
  components: {
    BindThree,
    UserDel,
    EditTruename
  },
  data () {
    return {
      isTruenameEdit: false
    }
  },
  computed: {
    ...mapState('organization/person', ['itemData', 'itemDatsReady', 'cId']),
    len () {
      if (this.itemData.projectInfo) {
        return this.itemData.projectInfo.length
      }
      return 0
    },
    joinPro () {
      return this.$t('message["78"]')
    },
    manageLimitTxt () {
      return this.$t('message["415"]')
    },
    setAdminTxt () {
      return this.$t('message["898"]').split('|')
    },
    mobileTit () {
      return this.$t('message["1107"]')
    },
    emailTit () {
      return this.$t('message["1505"]')
    }
  },
  methods: {
    ...mapActions('organization/person', ['setAdmin', 'fetchItemInfoDatas']),
    async setAdminHandler () {
      // let { isadmin } = this.itemData
      const chain = await this.setAdmin({ cid: this.$route.query.cid, adminid: this.itemData.userid })
      chain.onSuccess(async (raw) => {
        // this.itemData.isadmin = isadmin ? 0 : 1
        this.$message.success(this.$t('message["81"]') + '！')
        const chain = await this.fetchItemInfoDatas({ cid: this.cId, userid: this.itemData.userid })
        chain.fetch()
      })

        .fetch()
    },
    saveEditTrue (name) {
      this.itemData.truename = name
      this.isTruenameEdit = false
    },
    resetEdit () {
      this.isTruenameEdit = false
    },
    eidtTruename () {
      this.isTruenameEdit = true
    }
  }
}
</script>
<style lang="scss" scoped>
    .p-detail-box::v-deep {
      float: right;
      width: 909px;
      padding: 24px;
      position: relative;
      box-sizing: content-box;
      border-left: 1px solid #ebebeb;
      min-height: 500px;
      .iconicon-test66 {
        color:#ccc ;
        float: left;
        margin: 14px 0 0 0;
        cursor: pointer;
      }
      .form-box {
        margin-left: 50px;
        margin-top: 40px;
      }
      .ant-row:after {
        clear: both;
        content: '.';
        display: block;
        height: 0;
        visibility: hidden;
      }
      .ant-row {
        padding-left: 100px;
        .ant-input-number{
          width:160px;
        }
        .ant-form-item-label {
          float: left;
          width: 90px;
          margin-left: -100px;
          label {
          color: #666;
          }
        }
        .ant-form-item-control-wrapper {
          float: left;
          width: 100%;
        }
      }

      .company-name {
        color: #b3b3b3;
      }

      .tool-btn-box {
        position: absolute;
        right: 24px;
        top: 40px;
      }

      .p-detail-tit {
        padding: 8px 0 16px;
        border-bottom: 1px solid #ebebeb;
        .icon {
          font-size: 32px;
          color:#ccc;
          float: left;
          margin-right: 10px;
          margin-top: 6px;
        }
        .ant-form-inline {
          margin-top: 6px;
        }
        .ant-row {
          padding-left: 16px;
          margin-right: 8px;
        }

        strong {
          font-size: 18px;
          font-weight: bold;
          margin: 0 10px;
          float: left;
          line-height: 48px;
        }

        .p-role {
          float: left;
          line-height: 48px;
          height: 20px;
          line-height: 20px;
          padding: 0 8px;
          background: #BD7CEB;
          color: #fff;
          border-radius: 10px;
          font-size: 12px;
          vertical-align: middle;
          margin-top: 13px;
        }
        .admin-role {
          background: #4CA0F2
        }
      }
    }
</style>
